import LogoutIcon from "../icons/LogoutIcon";
import UserIcon from "../icons/UserIcon";
import GovahitIcon from "../icons/GovahitIcon";
import DashboardIcon from "../icons/DashboardIcon";
import {useEffect, useState} from "react";
import Dashboard from "./Dashboard";
import PersonalityRequests from "./PersonalityRequest";
import CompanyRequests from "./companyRequest";
import CanceledRequests from "./canceledRequest/CanceledRequests";
import Discount from "./discount/Discount";
import {apiClient} from "../../api/ApiClient";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {resetLeaderToken} from "../redux/actions/LeaderPortalAction";
import {Toaster} from "react-hot-toast";
import {getRolesFromToken} from "../methods/CommonMethods";

export default function PortalLeader() {

    const [active, setActive] = useState('personalityRequests');
    const [roles, setRoles] = useState([]);
    const token = useSelector(state => state.LeaderPortal.token)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const userRoles = getRolesFromToken(token);
        console.log(userRoles)
        setRoles(userRoles);
    }, []);

    const logout = () => {
        dispatch(resetLeaderToken());
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;
        navigate('/leader/login')
    }



    const getTheContainer = () => {
        switch (active) {
            case 'personalityRequests':
                return <PersonalityRequests />;
            case "companyRequests" :
                return <CompanyRequests />;
            case "canceledRequests" :
                return <CanceledRequests />
            case "discount" :
                return <Discount />
            default:
                return <PersonalityRequests />
        }
    }

    return(
        <div className={`d-flex`}>
            <Toaster/>
            <div style={{width: "24%", maxWidth: "250px", minHeight: "100vh"}} className={`leader_part`}>

                <div className={`d-flex justify-content-center mt-3`}>
                    <GovahitIcon />
                    <div className={`me-2`}>
                        <p className={`govahit-title`}>گواهیت</p>
                        <p className={`panel-text`}>پنل ادمین سامانه</p>
                    </div>
                </div>

                <div className={`leader_menu mt-2`}>

                    {/*<div*/}
                    {/*    className={`col-9 d-flex pointer ${active == '' ? 'leader_menu_item_active' : 'leader_menu_item'}`}*/}
                    {/*    onClick={ () => setActive('')}*/}
                    {/*>*/}
                    {/*    <DashboardIcon activeIcon={active == ''}/>*/}
                    {/*    <p className={`me-3 `}>میز کار</p>*/}
                    {/*</div>*/}

                    <div
                        className={`col-9 d-flex pointer ${active == 'personalityRequests' ? 'leader_menu_item_active' : 'leader_menu_item'}`}
                        onClick={ () => setActive('personalityRequests')}
                    >
                        <DashboardIcon activeIcon={active == 'personalityRequests'} />
                        <p className={`me-3`}> درخواست حقیقی</p>
                    </div>

                    <div
                        className={`col-9 d-flex pointer ${active == 'companyRequests' ? 'leader_menu_item_active' : 'leader_menu_item'}`}
                        onClick={ () => setActive('companyRequests')}
                    >
                        <DashboardIcon activeIcon={active == 'companyRequests'} />
                        <p className={`me-3`}>درخواست حقوقی</p>
                    </div>

                    <div
                        className={`col-9 d-flex pointer ${active == 'canceledRequests' ? 'leader_menu_item_active' : 'leader_menu_item'}`}
                        onClick={ () => setActive('canceledRequests')}
                    >
                        <DashboardIcon activeIcon={active == 'canceledRequests'} />
                        <p className={`me-3`}>انصرافی</p>
                    </div>

                    {roles.includes("discount_code") && <div
                        className={`col-9 d-flex pointer ${active == 'discount' ? 'leader_menu_item_active' : 'leader_menu_item'}`}
                        onClick={() => setActive('discount')}
                    >
                        <DashboardIcon activeIcon={active == 'discount'}/>
                        <p className={`me-3`}>کد تخفیف</p>
                    </div>}

                </div>
            </div>

            <div className={`width_of_parent`} style={{padding: "0% 0.15%", width: "-webkit-fill-available"}}>

                <div className={`row justify-content-between leader_part px-4 py-2`}>
                    <div className={`col-2`}  style={{lineHeight: "2rem"}}>میز کار</div>

                    <div className={`col-3 leader-logout pointer`} onClick={logout}>
                        <div className={`col d-flex`}>
                            <UserIcon />
                            <span className={`me-2 mt-1`}>راهبر سامانه</span>
                        </div>
                        <div className={`col-2 text-start`}><LogoutIcon /></div>
                    </div>

                </div>

                <div className={`m-4 leader_part p-2 px-4 portal_body`} style={{minHeight: "88vh"}}>
                    {getTheContainer()}
                </div>

            </div>
        </div>
    )
}